import { MenuItem, Switch, UnstyledButton, useMantineColorScheme } from '@mantine/core';
import { Menu, rem } from '@mantine/core';
import {
  IconSettings,
  IconLogout,
  IconCreditCard,
  IconMoon,
  IconSun,
  IconUser,
  IconLanguage,
  IconUsers,
} from '@tabler/icons-react';
import { Avatar } from '@mantine/core';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

export function UserWidget() {
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  const navigate = useNavigate();
  const { logout, user } = useAuth0();

  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
  };

  const handleLogout = () => {
    logout({
      // logoutParams: {
      //   returnTo: window.location.origin,
      // },
    });
  };

  return (
    <Menu
      shadow="md"
      width={200}
      withinPortal={true}
      transitionProps={{ transition: 'pop-top-right' }}
    >
      <Menu.Target>
        <Avatar
          component={UnstyledButton}
          src={user?.picture}
          color="indigo"
          alt={user?.name}
        ></Avatar>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{user?.name}</Menu.Label>
        <Menu.Item
          onClick={() => navigate('/profile')}
          leftSection={<IconUser style={{ width: rem(14), height: rem(14) }} />}
        >
          {t('user_widget.profile')}
        </Menu.Item>
        <Menu.Item
          onClick={() => navigate('/patients')}
          leftSection={<IconUsers style={{ width: rem(14), height: rem(14) }} />}
        >
          {t('user_widget.patients')}
        </Menu.Item>
        {/* <Menu.Item leftSection={<IconSettings style={{ width: rem(14), height: rem(14) }} />}>
          {t('user_widget.settings')}
        </Menu.Item>
        <Menu.Item leftSection={<IconCreditCard style={{ width: rem(14), height: rem(14) }} />}>
          {t('user_widget.payments')}
        </Menu.Item> */}
        <MenuItem
          onClick={() => setColorScheme(colorScheme === 'dark' ? 'light' : 'dark')}
          leftSection={
            colorScheme === 'dark' ? (
              <IconSun style={{ width: rem(14), height: rem(14) }} />
            ) : (
              <IconMoon style={{ width: rem(14), height: rem(14) }} />
            )
          }
        >
          {colorScheme === 'dark' ? t('user_widget.light_mode') : t('user_widget.dark_mode')}
        </MenuItem>
        <Menu.Item
          leftSection={<IconLanguage style={{ width: rem(14), height: rem(14) }} />}
          onClick={toggleLanguage}
        >
          {t('user_widget.language')}
        </Menu.Item>

        <Menu.Divider />
        <Menu.Item
          leftSection={<IconLogout style={{ width: rem(14), height: rem(14) }} />}
          onClick={handleLogout}
        >
          {t('user_widget.logout')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
